var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_38581)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.30396 7.53317C1.30396 7.26854 1.56859 7.00391 1.83322 7.00391C2.09785 7.00391 2.36248 7.26854 2.36248 7.53317C2.36248 7.70959 2.36248 8.5917 2.36248 10.1795C2.36248 10.7641 2.8364 11.238 3.42101 11.238H9.77217C10.3568 11.238 10.8307 10.7641 10.8307 10.1795V7.53317C10.8307 7.24087 11.0677 7.00391 11.36 7.00391C11.6523 7.00391 11.8892 7.24087 11.8892 7.53317V10.1795C11.8892 11.3487 10.9414 12.2965 9.77217 12.2965H3.42101C2.25179 12.2965 1.30396 11.3487 1.30396 10.1795C1.30396 8.5917 1.30396 7.70959 1.30396 7.53317Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.12591 2.2402C7.12591 1.9479 6.88895 1.71094 6.59665 1.71094C6.30434 1.71094 6.06738 1.9479 6.06738 2.2402L6.06738 8.59136C6.06738 8.88367 6.30434 9.12063 6.59665 9.12063C6.88895 9.12063 7.12591 8.88367 7.12591 8.59136L7.12591 2.2402Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32441 4.72952C4.11772 4.93621 3.78261 4.93621 3.57592 4.72952C3.36923 4.52283 3.36923 4.18771 3.57592 3.98102L6.22223 1.33471C6.42128 1.13566 6.7413 1.12724 6.95054 1.31555L9.59686 3.69724C9.81412 3.89278 9.83174 4.22743 9.6362 4.4447C9.44065 4.66196 9.10601 4.67958 8.88874 4.48404L6.61566 2.43826L4.32441 4.72952Z",
    fill: "#B0B7C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_38581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7023,
    height: 12.7023,
    fill: "white",
    transform: "translate(0.245361 0.652344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.39e6fef99b5d5d4dc3185c010aadaa78.svg";
export { ForwardRef as ReactComponent };